import { useIqamaStore } from '../state/storeIqamaDelay';
import { useMonth } from './useMonth';

export const useTimes = () => {
	const IQFajr = useIqamaStore( ( state ) => state.IQFajr );
	const IQDhuhr = useIqamaStore( ( state ) => state.IQDhuhr );
	const IQAsr = useIqamaStore( ( state ) => state.IQAsr );
	const IQMaghrib = useIqamaStore( ( state ) => state.IQMaghrib );
	const IQIsha = useIqamaStore( ( state ) => state.IQIsha );
	const { MonthName } = useMonth();
	const timePrayer = async ( times, startDate ) => {
		const day = startDate.getDate();
		const title =
			day +
			' ' +
			MonthName( startDate.getMonth() ) +
			' ' +
			startDate.getFullYear();
		times.fajr_begins = times.fajr;
		times.dhuhr_begins = times.dhuhr;
		times.asr_begins = times.asr;
		times.maghrib_begins = times.maghrib;
		times.isha_begins = times.isha;
		times.fajr_iqamah = new Date(
			new Date( '1970-01-01 ' + times.fajr ).getTime() +
				Number( IQFajr ) * 60000
		).toLocaleTimeString( 'en-UK', {
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
		} );
		times.dhuhr_iqamah = new Date(
			new Date( '1970-01-01 ' + times.dhuhr ).getTime() +
				Number( IQDhuhr ) * 60000
		).toLocaleTimeString( 'en-UK', {
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
		} );
		times.asr_iqamah = new Date(
			new Date( '1970-01-01 ' + times.asr ).getTime() +
				Number( IQAsr ) * 60000
		).toLocaleTimeString( 'en-UK', {
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
		} );
		times.maghrib_iqamah = new Date(
			new Date( '1970-01-01 ' + times.maghrib ).getTime() +
				Number( IQMaghrib ) * 60000
		).toLocaleTimeString( 'en-UK', {
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
		} );
		times.isha_iqamah = new Date(
			new Date( '1970-01-01 ' + times.isha ).getTime() +
				Number( IQIsha ) * 60000
		).toLocaleTimeString( 'en-UK', {
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
		} );
		times.today = startDate.getDate().toString();
		times.date = title;
		times.currentDate =
			startDate.getDate() +
			' ' +
			MonthName( Number( startDate.getMonth() ) ) +
			' ' +
			startDate.getFullYear();
		times.currentMonth = MonthName( Number( startDate.getMonth() ) );

		times.title = title;
		times.date =
			startDate.getFullYear() +
			'-' +
			( startDate.getMonth() + 1 ) +
			'-' +
			startDate.getDate();
	};

	return { timePrayer };
};
